function Success() {
    return (
        <svg
            width="22"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="16" cy="16" r="16" fill="#752AFF" />
            <path
                d="M19.6832 11.8547L14.4867 17.0515L12.3163 14.8811C11.843 14.4077 11.078 14.4077 10.6047 14.8811C10.1314 15.3544 10.1314 16.1194 10.6047 16.5927L13.6309 19.6191C13.8669 19.8551 14.1768 19.9737 14.4867 19.9737C14.7966 19.9737 15.1064 19.8551 15.3425 19.6191L21.3948 13.5664C21.8681 13.0931 21.8681 12.3281 21.3948 11.8547C20.9215 11.3814 20.1565 11.3814 19.6832 11.8547Z"
                fill="white"
            />
        </svg>
    );
}

export default Success;
